import type { VirtualWarehouseSearchParams } from '../virtual-warehouse/models/virtual-warehouse.model';

export function parseVirtualListCityCodeFromForm(raw: unknown): number | undefined {
  if (raw == null || raw === '') return undefined;
  if (typeof raw === 'string') {
    const n = Number.parseInt(raw, 10);
    return Number.isNaN(n) ? undefined : n;
  }
  if (typeof raw === 'number') {
    return Number.isNaN(raw) ? undefined : raw;
  }
  return undefined;
}

export function mergeVirtualWarehouseListSearch(
  current: VirtualWarehouseSearchParams,
  formParams: { name?: string; cityCode?: unknown },
): VirtualWarehouseSearchParams {
  const searchName = formParams.name?.trim();
  const searchCityCode = parseVirtualListCityCodeFromForm(formParams.cityCode);
  const validCity =
    searchCityCode !== undefined && !Number.isNaN(searchCityCode)
      ? searchCityCode
      : undefined;
  return {
    ...current,
    name: searchName && searchName.length > 0 ? searchName : undefined,
    cityCode: validCity,
    cityName: undefined,
    status: undefined,
    page: 0,
  };
}

export function virtualWarehouseListHasActiveFilters(
  p: Pick<VirtualWarehouseSearchParams, 'name' | 'cityCode'>,
): boolean {
  return !!(p.name || p.cityCode);
}

export function resetVirtualWarehouseListSearch(
  size: number,
): Pick<
  VirtualWarehouseSearchParams,
  'name' | 'status' | 'cityName' | 'cityCode' | 'page' | 'size'
> {
  return {
    name: undefined,
    status: undefined,
    cityName: undefined,
    cityCode: undefined,
    page: 0,
    size,
  };
}
